import { useAtomValue, useSetAtom } from "jotai";
import { loadable } from "jotai/utils";
import { useCallback, useEffect } from "react";

import {
	$downloadStatus,
	$error,
	$restartApp,
	$updateAvailableOnStartup,
	$updateMetadata,
	$updater,
	$updaterOnStartup,
} from "../../internal/autoupdater/autoupdater.atom";
import { env } from "../../internal/env/env";

export const useAutoUpdaterOnStartup = () => {
	const updateAvailableOnStartup = useAtomValue($updateAvailableOnStartup);
	const updaterOnStartup = useSetAtom($updaterOnStartup);

	return {
		updaterOnStartup,
		updateAvailableOnStartup,
	};
};

export const useAutoUpdater = () => {
	const updateMetadata = useAtomValue(loadable($updateMetadata));
	const refresh = useSetAtom($updateMetadata);
	const updater = useSetAtom($updater);
	const downloadStatus = useAtomValue($downloadStatus);
	const restartApp = useSetAtom($restartApp);
	const error = useAtomValue($error);

	// I am sure there is a better way to do this.
	useEffect(() => {
		if (!env.isDesktopApp) {
			return;
		}
		if (env.appEnv === "local") {
			return;
		}
		if (updateMetadata.state !== "hasData" || !updateMetadata.data) {
			return;
		}
		if (updateMetadata.data.latestVersion === updateMetadata.data.currentVersion) {
			return;
		}

		// do not start a new download if one is already in progress
		if (downloadStatus !== "idle") {
			return;
		}

		updater(updateMetadata.data.latestVersion);
	}, [updateMetadata, updater, downloadStatus]);

	const restarter = useCallback(async () => {
		if (!env.isDesktopApp) {
			return;
		}
		if (updateMetadata.state !== "hasData" || !updateMetadata.data) {
			return;
		}

		restartApp({ versionDownloading: updateMetadata.data.latestVersion });
	}, [restartApp, updateMetadata]);

	return {
		isLoading: updateMetadata.state === "loading",
		updateMetadata: updateMetadata.state === "hasData" ? updateMetadata.data : undefined,
		refresh,
		downloadStatus,
		restarter,
		error,
	};
};
